import React, { useEffect, useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import theme from "@src/styles/theme"
import { document, window } from "browser-monads"

const TocWrapper = styled.div`
  width: 29%;
  max-width: 310px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 600px) {
    display: none;
  }
  position: sticky;
  height: fit-content;
  top: ${props => props.theme.header.tablet.height}px;
  @media only screen and (${props => props.theme.screen.small.min}) {
    top: ${props => props.theme.header.small.height}px;
  }
  @media only screen and (${props => props.theme.screen.large.min}) {
    top: ${props => props.theme.header.large.height}px;
  }
`

const TocTitle = styled.div`
  color: ${theme.secondary900};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0.25px;
`

const LinkHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const TocLink = styled.a`
  color: ${theme.silverShade};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.07px;
  text-decoration-line: underline;
  cursor: pointer;
`

const Toc = ({ refference }) => {
  const [links, setLinks] = useState([])

  useEffect(() => {
    if (refference?.current) {
      const headers = refference.current.querySelectorAll("h2")
      const linksArray = Array.from(headers).map((header, index) => {
        const id = `toc-${index}`
        header.id = id
        return { id, text: header.innerText }
      })
      setLinks(linksArray)
    }
  }, [refference])

  const handleClick = (e, id) => {
    e.preventDefault()
    const targetElement = document.getElementById(id)
    if (targetElement) {
      const yOffset = -120
      const yPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: yPosition, behavior: "smooth" })
    }
  }

  return (
    <TocWrapper>
      <TocTitle>Table of contents</TocTitle>
      <LinkHolder>
        {links.map(link => (
          <TocLink
            key={link.id}
            href={`#${link.id}`}
            onClick={e => handleClick(e, link.id)}
          >
            {link.text}
          </TocLink>
        ))}
      </LinkHolder>
    </TocWrapper>
  )
}

Toc.propTypes = {
  refference: PropTypes.object.isRequired,
}

export default Toc
